import React, { useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  Slider,
} from '@lb-classroom/ui';
import TimeslotConstants from '../../../../constants/TimeslotConstants';
import { withTranslation, WithTranslation } from 'next-i18next';
import classnames from 'classnames';

const TIMESLOT_LIST = TimeslotConstants.slotArray;

interface TutorFilterTimeRangePickerOwnProps {
  min?: number;
  max?: number;
  chosenTimeRange?: number[];
  handleMoveRange?: (range: number[]) => void;
  updateChosenTimeRange?: (range: number[]) => void;
  onClickOuter?: () => void;
}

type TutorFilterTimeRangePickerProps = TutorFilterTimeRangePickerOwnProps &
  WithTranslation;

const TutorFilterTimeRangePicker = (props: TutorFilterTimeRangePickerProps) => {
  const {
    t,
    min = 1,
    max = 49,
    chosenTimeRange = [1, 49],
    handleMoveRange,
    updateChosenTimeRange,
  } = props;
  const [show, setShow] = useState(false);
  const [localRange, setLocalRange] = useState(chosenTimeRange);

  const getTimeLabel = (value: number) => {
    return TIMESLOT_LIST[value - 1] || '';
  };

  const getTimeRangeSentence = () => {
    const start = chosenTimeRange[0];
    const end = chosenTimeRange[1];
    if (start === 1 && end === 49) {
      return t('student.tutorList.allDay');
    }
    return `${TIMESLOT_LIST[chosenTimeRange[0] - 1]} - ${
      TIMESLOT_LIST[chosenTimeRange[1] - 1]
    }`;
  };

  const handleOpenChange = (flag: boolean) => {
    setShow(flag);
    if (flag) {
      setLocalRange(chosenTimeRange);
    }
  };

  const handleSliderChange = (value: number[]) => {
    setLocalRange(value);
    handleMoveRange?.(value);
  };

  const handleSliderCommit = (value: number[]) => {
    updateChosenTimeRange?.(value);
  };

  const wrapClass = classnames(
    'h-16 w-full flex justify-center items-center hover:bg-light-gray border-r border-light-gray',
    {
      'bg-light-gray': show,
    },
  );

  return (
    <DropdownMenu open={show} onOpenChange={handleOpenChange}>
      <DropdownMenuTrigger asChild>
        <a className="cursor-pointer" onClick={(e) => e.preventDefault()}>
          <div className={wrapClass}>{getTimeRangeSentence()}</div>
        </a>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-96 p-4">
        <div className="text-center text-sm font-medium mb-4">
          {getTimeLabel(localRange[0])} - {getTimeLabel(localRange[1])}
        </div>
        <div className="px-2 mb-4">
          <Slider
            min={min}
            max={max}
            step={1}
            value={localRange}
            onValueChange={handleSliderChange}
            onValueCommit={handleSliderCommit}
          />
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default withTranslation('common')(TutorFilterTimeRangePicker);
